// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Photo-module--cls1--2BrGM","cls2":"styles-Photo-module--cls2--10E0x styles-Photo-module--cls1--2BrGM"};